define('ProductListDetailsLaterFix.ProductList.DetailsLater', [
    'ProductList.DetailsLater.View',
    'underscore',
    'Profile.Model'
], function ProductListDetailsLaterFix(
    ProductListDetailsLaterView,
    _,
    ProfileModel
) {
    'use strict';

    _.extend(ProductListDetailsLaterView.prototype, {
        render: function render() {
            var self = this;
            if (ProfileModel.getInstance().get('isLoggedIn') === 'T') {
                this._render();
                _.defer(function deferFn() {
                    self.$('[data-action="pushable"]').scPush();
                });
            } else {
                this.$el.empty();
            }
            return this;
        }
    });
});
